// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1DpHF","actions":"GroupTable_actions__2qHUZ","deleteModalFooter":"GroupTable_deleteModalFooter__3QmuU"};